/*
 * POOM — promocja "Pilka gratis od X zl" (snippets/pk-gratis-pilka.liquid).
 *  - po kazdej zmianie koszyka (zdarzenie cart:update z Tinkera) pobiera /cart.js i odswieza stan karty:
 *    ile w koszyku bez pilki, ile brakuje, czy pilka juz jest i czy jest gratis (cena linii 0 zl = rabat
 *    automatyczny z panelu zadzialal),
 *  - wybor koloru podmienia zdjecie i nazwe,
 *  - "Dodaj pilke" -> POST /cart/add.js (z sekcjami szuflady koszyka jak w product-form.js Tinkera) i zdarzenie
 *    cart:update, zeby szuflada/ikona koszyka odswiezyly sie i szuflada otworzyla jak po zwyklym dodaniu.
 */
(() => {
  const money = (cents) => `${(cents / 100).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} zł`;
  const moneyShort = (cents) => (cents % 100 === 0 ? `${cents / 100} zł` : money(cents));
  const root = window.Shopify?.routes?.root || '/';

  const widgets = () => [...document.querySelectorAll('[data-pk-pilka]')];

  // tryb "addon": produkt za X zl przy dobraniu DOWOLNEGO innego produktu (baner Aktywne promocje na glownej)
  const renderAddon = (w, cart) => {
    const id = Number(w.dataset.productId);
    const price = Number(w.dataset.price);
    const promo = Number(w.dataset.promoPrice);
    const name = w.dataset.itemName || 'produkt';
    const Name = w.dataset.itemNom || name.charAt(0).toUpperCase() + name.slice(1); // mianownik do zdan
    let others = 0;
    let line = null;
    for (const item of cart.items || []) {
      if (item.product_id === id) line = item;
      else others += item.quantity;
    }
    const reached = others > 0;
    const applied = !!line && line.final_line_price <= promo * line.quantity;
    w.classList.toggle('pk-pilka--reached', reached);
    w.classList.toggle('pk-pilka--in-cart', !!line);
    const status = w.querySelector('[data-pk-pilka-status]');
    if (status) {
      if (line && applied) status.textContent = `${Name} jest w koszyku za ${moneyShort(promo)}.`;
      else if (line && reached) status.textContent = `${Name} jest w koszyku — rabat naliczy się w koszyku.`;
      else if (line) status.textContent = `${Name} jest w koszyku w cenie ${money(line.final_line_price)}. Dodaj dowolny inny produkt, a cena spadnie do ${moneyShort(promo)}.`;
      else if (reached) status.textContent = `Masz produkty w koszyku — dodaj ${name} za ${moneyShort(promo)}.`;
      else status.textContent = `Dodaj dowolny produkt do koszyka, a ${name} dobierzesz za ${moneyShort(promo)}.`;
    }
    const picker = w.querySelector('[data-pk-pilka-picker]');
    if (picker) picker.hidden = !!line;
    const btnText = w.querySelector('[data-pk-pilka-btn-text]');
    if (btnText) btnText.textContent = `Dodaj ${name} za ${reached ? moneyShort(promo) : money(price)}`;
  };

  const render = (w, cart) => {
    if (w.dataset.mode === 'addon') return renderAddon(w, cart);
    const ballId = Number(w.dataset.productId);
    const threshold = Number(w.dataset.threshold);
    const price = Number(w.dataset.price);
    let qualifying = 0;
    let ballLine = null;
    for (const item of cart.items || []) {
      if (item.product_id === ballId) ballLine = item;
      else qualifying += item.final_line_price;
    }
    const missing = Math.max(0, threshold - qualifying);
    const reached = missing === 0;
    const free = !!ballLine && ballLine.final_line_price === 0;

    w.classList.toggle('pk-pilka--reached', reached);
    w.classList.toggle('pk-pilka--in-cart', !!ballLine);
    const bar = w.querySelector('[data-pk-pilka-bar]');
    if (bar) bar.style.width = `${Math.min(100, Math.round((qualifying / threshold) * 100))}%`;
    const badge = w.querySelector('[data-pk-pilka-badge]');
    if (badge) badge.textContent = reached ? 'Gratis' : `od ${moneyShort(threshold)}`;

    const status = w.querySelector('[data-pk-pilka-status]');
    if (status) {
      if (ballLine && free) status.textContent = `Piłka jest w koszyku gratis. Kolor: ${ballLine.variant_title}.`;
      else if (ballLine && reached) status.textContent = `Piłka (${ballLine.variant_title}) jest w koszyku, masz ${money(qualifying)} — rabat 100% na piłkę nalicza się w koszyku.`;
      else if (ballLine) status.textContent = `Piłka (${ballLine.variant_title}) jest w koszyku w cenie ${money(ballLine.final_line_price)}. Brakuje ${money(missing)} do gratisu — po dodaniu produktów cena piłki spadnie do 0 zł.`;
      else if (reached) status.textContent = `Masz ${money(qualifying)} w koszyku — wybierz kolor i dodaj piłkę gratis.`;
      else if (qualifying > 0) status.textContent = `Masz ${money(qualifying)} w koszyku, brakuje ${money(missing)}. Dodaj produkty za ${money(missing)}, a piłka będzie gratis.`;
      else status.textContent = `Dodaj produkty za ${moneyShort(threshold)}, a piłkę w wybranym kolorze dostaniesz gratis.`;
    }
    const picker = w.querySelector('[data-pk-pilka-picker]');
    if (picker) picker.hidden = !!ballLine;
    const btnText = w.querySelector('[data-pk-pilka-btn-text]');
    if (btnText) btnText.textContent = reached ? 'Dodaj piłkę gratis' : `Dodaj piłkę za ${money(price)}`;
    // koszyk: wybor koloru widoczny zawsze, dopoki pilki nie ma w koszyku (user 2026-10-02)
  };

  let refreshing = null;
  const refresh = () => {
    if (!widgets().length) return;
    if (refreshing) return refreshing;
    refreshing = fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => widgets().forEach((w) => render(w, cart)))
      .catch(() => {})
      .finally(() => { refreshing = null; });
    return refreshing;
  };

  // wybor koloru
  document.addEventListener('change', (e) => {
    const input = e.target;
    if (!(input instanceof HTMLInputElement) || !input.name.startsWith('pk-pilka-kolor')) return;
    const w = input.closest('[data-pk-pilka]');
    if (!w) return;
    const name = w.querySelector('[data-pk-pilka-color]');
    if (name) name.textContent = input.dataset.name || '';
    const img = w.querySelector('[data-pk-pilka-img]');
    if (img && input.dataset.image) img.src = input.dataset.image;
  });

  // dodanie do koszyka
  document.addEventListener('click', async (e) => {
    const btn = e.target instanceof Element ? e.target.closest('[data-pk-pilka-add]') : null;
    if (!btn) return;
    e.preventDefault();
    const w = btn.closest('[data-pk-pilka]');
    const input = w?.querySelector('input[name^="pk-pilka-kolor"]:checked');
    const err = w?.querySelector('[data-pk-pilka-err]');
    if (!w || !input) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    if (err) err.hidden = true;
    try {
      const body = new FormData();
      body.append('id', input.value);
      body.append('quantity', '1');
      // sekcje szuflady koszyka — jak w product-form.js Tinkera; morph podmienia je bez przeladowania
      const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId).filter(Boolean);
      if (sectionIds.length) body.append('sections', sectionIds.join(','));
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body });
      const json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || json.message || 'Nie udało się dodać piłki');
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: json, sourceId: 'pk-gratis-pilka', data: { source: 'product-form-component', itemCount: 1, productId: w.dataset.productId, variantId: input.value, sections: json.sections || {} } },
      }));
      await refresh();
    } catch (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; }
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  });

  document.addEventListener('cart:update', () => setTimeout(refresh, 80));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
